import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/continent-2.svg")